// /client/src/components/StudentProjectDetails.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import "./StudentProjectDetails.css";
import { getStudentIdFromToken } from "./utils/auth"; // make sure this path is correct

const backgroundStyle = {
  background: "url('/background.png') center/cover no-repeat",
  minHeight: "100vh"
};

function StudentProjectDetails() {
  const { project_id } = useParams();
  const [project, setProject] = useState(null);
  const [bidAmount, setBidAmount] = useState(null);
  const [bidInput, setBidInput] = useState("");

  useEffect(() => {
    async function fetchProjectAndBid() {
      try {
        const token = localStorage.getItem("token");

        const projectRes = await fetch(
          `http://localhost:5002/dashboardrouter/project/${project_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const projectData = await projectRes.json();
        setProject(projectData);

        const bidRes = await fetch(
          `http://localhost:5002/student/bidamount/${project_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (bidRes.ok) {
          const bidData = await bidRes.json();
          setBidAmount(bidData.bid_amount);
        } else {
          setBidAmount(null);
        }
      } catch (error) {
        console.error("Error fetching project or bid:", error);
      }
    }

    fetchProjectAndBid();
  }, [project_id]);

  const handleBid = async () => {
    if (!bidInput) {
      alert("Please enter a bid amount.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const studentId = getStudentIdFromToken();

      const response = await fetch("http://localhost:5002/student/bid", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          project_id: project.project_id,
          student_id: studentId,
          bid_amount: bidInput,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        alert("Bid submitted successfully!");
        setBidAmount(bidInput);
        setBidInput("");
      } else {
        alert(data.error || "Failed to submit bid.");
      }
    } catch (error) {
      console.error("Bid submission failed:", error);
    }
  };

  if (!project) {
    return <div className="project-loading">Loading...</div>;
  }

  return (
    <div className="project-details-page" style={backgroundStyle}>
      <div className="project-details-box">
        <div className="project-main">
          <h2 className="project-title">{project.project_title}</h2>

          <div className="project-section"><strong>Client:</strong> {project.client}</div>
          <div className="project-section"><strong>Overview:</strong><p>{project.project_overview}</p></div>
          <div className="project-section"><strong>Scope of Work:</strong><p>{project.scope_of_work}</p></div>
          <div className="project-section"><strong>Technical Requirements:</strong><p>{project.technical_requirements}</p></div>
          <div className="project-section"><strong>Deliverables:</strong><p>{project.deliverables}</p></div>
          <div className="project-section"><strong>Acceptance Criteria:</strong><p>{project.acceptance_criteria}</p></div>
          <div className="project-section"><strong>Changes:</strong><p>{project.changes}</p></div>
          <div className="project-section"><strong>Start Date:</strong> {moment(project.start_date).format("YYYY-MM-DD hh:mm A")}</div>
        </div>

        <div className="project-eta-box">
          <h3>Project ETA</h3>
          <p>{moment(project.eta).format("YYYY-MM-DD hh:mm A")}</p>
        </div>
      </div>

      <div className="project-bid-box">
        {bidAmount !== null ? (
          <p><strong>Your Bid:</strong> ₹{bidAmount}</p>
        ) : (
          <>
            <p className="no-bid">You have not placed a bid for this project yet.</p>
            <div style={{ marginTop: "10px" }}>
              <input
                type="number"
                placeholder="Enter bid amount"
                value={bidInput}
                onChange={(e) => setBidInput(e.target.value)}
                className="bid-input"
                style={{
                  padding: "10px",
                  borderRadius: "10px",
                  border: "1px solid #ccc",
                  marginRight: "10px"
                }}
              />
              <button onClick={handleBid} className="bid-btn">
                Submit Bid
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default StudentProjectDetails;
